{
  "map": {
    "address": "Address",
    "directions": "Get Directions",
    "results_count": "{start} - {end} of {count}",
    "load_error": "The map could not load. Please try again.",
    "back": "Back to Search",
    "external": "Open in Google Maps",
    "search_area": "Search this area",
    "auto": "Update when I move the map",
    "within_bounds": "within the map bounds"
  },
  "landing": {
    "skill_invalid": "Select an option from the list",
    "from": "From",
    "common_locations": "Common Locations",
    "geolocate": "Use my current location",
    "geolocating": "Retrieving your location...",
    "geolocated": "Current Location",
    "location": "Near",
    "required_location": "Near (required)",
    "location_invalid": "Enter a valid address, city, state, or zip",
    "search_location": "Search"
  },
  "no_address_available": "No address available",
  "show_on_map": "Show on Map",
  "distance_away": "{distance} away",
  "more_locations": "{count} other location | {count} other locations",
  "in_network": "In-network",
  "call": "Call {phoneNumber}",
  "contact": "Contact",
  "plans_accepted_heading": "Plans accepted",
  "plans_accepted_count": "{count} plan accepted | {count} plans accepted",
  "gender": "Gender",
  "languages_spoken": "Languages spoken",
  "board_certification": "Board certification",
  "education": "Education",
  "location_services": "Location services",
  "web_contact": "Web contact",
  "website": "Website",
  "email": "Email",
  "special_hours": "Special Hours:",
  "provider_group_alt": "A headshot of a provider who works at {name}",
  "location_alt": "A photo of {name}",
  "provider_alt": "A headshot of {name}",
  "video_label": "Video of {name}",
  "status_open": "open",
  "status_closed": "closed",
  "status_closing": "closing",
  "currently_closed": "Currently Closed",
  "always_open": "This location is always open.",
  "opens_at": "Opens {time}",
  "closes_at": "Closes {time}",
  "closes_in_summary": "in {minutes} min - {nextOpen}",
  "hide_hours": "Hide hours.",
  "show_hours": "Show hours.",
  "full_schedule": "Full Schedule",
  "appts_count": "{count} appts",
  "more_count": "{count} more",
  "results": {
    "accepting": "Accepts New Patients",
    "not_accepting": "Not Accepting New Patients",
    "lgbtqia_affirming_care": "LGBTQIA+ Affirming Care",
    "lgbtqia_affirming_care_tooltip": "Provider offers specialized care for transgender and nonbinary patients.",
    "video_visits_available": "Video Visits Available",
    "view_full_schedule": "View full schedule",
    "new_patients": "New Patients",
    "returning_patients": "Returning Patients",
    "location_disclaimer": "",
    "location_disclaimer_heading": "Important",
    "link_to_profile_card_variant": "outlined",
    "link_to_profile_message": "See provider profile for scheduling options.",
    "link_to_profile_label": "Go to profile",
    "employment_badge_icon": "Employment Badge Icon",
    "pagination_label": "Pagination",
    "previous": "Previous",
    "next": "Next",
    "select_a_date": "Select a Date",
    "show_next_dates": "Show next page of available appointment dates",
    "show_previous_dates": "Show previous page of available appointment dates",
    "more_locations": "More Locations",
    "other_locations_online_booking": "{count} other location with online booking | {count} other locations with online booking",
    "other_locations_accepting_patients": "{count} other location accepts new patients | {count} other locations accept new patients",
    "other_locations": "{count} other location | {count} other locations",
    "more_locations_count": "{count} More Location | {count} More Locations",
    "other_locations_region": "Other locations for {name}",
    "other_locations_loading": "Loading other locations",
    "other_locations_error": "The other locations could not be loaded.",
    "other_locations_retry": "Try again",
    "closest_appointment_is": "Closest appointment is",
    "jump_to_date": "Jump to date",
    "wait_time_tooltip": "The wait time is an estimation of when you might be seen. The wait time might change if other patients with more severe conditions arrive at the clinic.",
    "go_to_date": "Go to date",
    "pagination_first": "First",
    "results_per_page": "Results per page",
    "map_banner_prompt": "Looking for providers near you?",
    "map_banner_cta": "Switch to map view.",
    "age_group_notice": "For an even better match choose an age group.",
    "carousel_label": "Providers Carousel"
  },
  "more_label": "{count} more on {date}",
  "view_full_schedule": "View full schedule",
  "slot_label": "Schedule an appointment at {time} on {date}"
}
